/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {UpdateGrantResources} from '../models/UpdateGrantResources';
import type {UpdateGrantResourcesResult} from '../models/UpdateGrantResourcesResult';

export interface BulkAssignGrantResources$Request {
    updateGrantResources: UpdateGrantResources;
    reason?: string;
}

export interface BulkAssignGrantResources$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkAssignGrantResourcesRequest = createAction<PayloadData<void, BulkAssignGrantResources$Request>>('BULK_ASSIGN_GRANT_RESOURCES__BULK_ASSIGN_GRANT_RESOURCES__REQUEST');
export const bulkAssignGrantResourcesSuccess = createAction<PayloadData<string, BulkAssignGrantResources$Request>>('BULK_ASSIGN_GRANT_RESOURCES__BULK_ASSIGN_GRANT_RESOURCES__SUCCESS');
export const bulkAssignGrantResourcesFailure = createAction<PayloadData<Error, BulkAssignGrantResources$Request, true>>('BULK_ASSIGN_GRANT_RESOURCES__BULK_ASSIGN_GRANT_RESOURCES__FAILURE');

export const bulkAssignGrantResourcesActions = [
    bulkAssignGrantResourcesRequest,
    bulkAssignGrantResourcesSuccess,
    bulkAssignGrantResourcesFailure
] as const;

/**
 * @param {UpdateGrantResources} meta.updateGrantResources
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkAssignGrantResources = (meta: BulkAssignGrantResources$Request, config?: BulkAssignGrantResources$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: bulkAssignGrantResourcesActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/bulk-actions/grants/assign-resouces`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.updateGrantResources,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface BulkAssignGrantResourcesProgress$Request {
    id: string;
}

export interface BulkAssignGrantResourcesProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkAssignGrantResourcesProgressRequest = createAction<PayloadData<void, BulkAssignGrantResourcesProgress$Request>>('BULK_ASSIGN_GRANT_RESOURCES__BULK_ASSIGN_GRANT_RESOURCES_PROGRESS__REQUEST');
export const bulkAssignGrantResourcesProgressSuccess = createAction<PayloadData<BulkProgress, BulkAssignGrantResourcesProgress$Request>>('BULK_ASSIGN_GRANT_RESOURCES__BULK_ASSIGN_GRANT_RESOURCES_PROGRESS__SUCCESS');
export const bulkAssignGrantResourcesProgressFailure = createAction<PayloadData<Error, BulkAssignGrantResourcesProgress$Request, true>>('BULK_ASSIGN_GRANT_RESOURCES__BULK_ASSIGN_GRANT_RESOURCES_PROGRESS__FAILURE');

export const bulkAssignGrantResourcesProgressActions = [
    bulkAssignGrantResourcesProgressRequest,
    bulkAssignGrantResourcesProgressSuccess,
    bulkAssignGrantResourcesProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkAssignGrantResourcesProgress = (meta: BulkAssignGrantResourcesProgress$Request, config?: BulkAssignGrantResourcesProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: bulkAssignGrantResourcesProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/grants/assign-resouces/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAssignGrantResourcesResult$Request {
    id: string;
}

export interface GetAssignGrantResourcesResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAssignGrantResourcesResultRequest = createAction<PayloadData<void, GetAssignGrantResourcesResult$Request>>('BULK_ASSIGN_GRANT_RESOURCES__GET_ASSIGN_GRANT_RESOURCES_RESULT__REQUEST');
export const getAssignGrantResourcesResultSuccess = createAction<PayloadData<UpdateGrantResourcesResult, GetAssignGrantResourcesResult$Request>>('BULK_ASSIGN_GRANT_RESOURCES__GET_ASSIGN_GRANT_RESOURCES_RESULT__SUCCESS');
export const getAssignGrantResourcesResultFailure = createAction<PayloadData<Error, GetAssignGrantResourcesResult$Request, true>>('BULK_ASSIGN_GRANT_RESOURCES__GET_ASSIGN_GRANT_RESOURCES_RESULT__FAILURE');

export const getAssignGrantResourcesResultActions = [
    getAssignGrantResourcesResultRequest,
    getAssignGrantResourcesResultSuccess,
    getAssignGrantResourcesResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAssignGrantResourcesResult = (meta: GetAssignGrantResourcesResult$Request, config?: GetAssignGrantResourcesResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getAssignGrantResourcesResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/grants/assign-resouces`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

